import React from 'react'
import { withStyles } from '@material-ui/core/styles';
import { compose } from 'redux'
import { connect } from 'react-redux'
import Box from '@material-ui/core/Box';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Avatar from '@material-ui/core/Avatar';
import Divider from '@material-ui/core/Divider';
import { firestoreConnect, isLoaded } from 'react-redux-firebase'
import { getCollection } from '../../constant';
import Loader from '../../components/custom/loader'
import ChatIcon from '@material-ui/icons/Chat';
import Badge from '@material-ui/core/Badge';





const styles = {
  notiMain: {
    maxWidth: 400,
    minWidth: 250,
    width: '100%',
    height: '100%',
    overflow:'hidden'

  },
  row: {
    display: 'flex',
    justifyContent: 'center',
  },
  link: {
    textDecoration: 'none',
    color: "white"
  },
  root: {
    width: '100%',
    maxWidth: 400,
    // backgroundColor: theme.palette.background.paper,
    position: 'relative',
    overflow: 'auto',
    // maxHeight: 300,
    maxHeight: 'calc(100% - 50px)'
  },
  listSection: {
    backgroundColor: 'inherit',
  },
  ul: {
    backgroundColor: 'inherit',
    padding: 0,
  },
  bold: { fontWeight: 'bold' }

};
class ChatUsers extends React.Component {
  render() {
    const { classes, users, profile, userClick, chats = [], chatNotifications = [] } = this.props;

    if (!isLoaded(chats) || !isLoaded(users)) {
      return <Loader />
    }

    const allUsers = [];

    for (let i = 0; i < chats.length; i++) {
      for (let j = 0; j < chats[i].users.length; j++) {
        if (chats[i].users[j].id !== profile.id) {

          let count = 0;
          const notifications = [];
          console.log("chatNotifications : ", chatNotifications)
          for (let k = 0; k < chatNotifications.length; k++) {
            if (chatNotifications[k] && (chatNotifications[k].roomId == chats[i].id)) {
              count++;
              notifications.push(chatNotifications[k]);
            }
          }
          allUsers.push({ ...chats[i].users[j], updatedAt: chats[i].updatedAt, roomId: chats[i].id, count, notifications })
        }
      }
    }

    allUsers.sort((a, b) => {
      return (b.updatedAt || b.createdAt) - (a.updatedAt || a.createdAt);
    });

    for (let i = 0; i < users.length; i++) {
      let alreadyAdded = false;
      if (users[i].id !== profile.id) {
        for (let user in allUsers) {
          if (allUsers[user].id == users[i].id) {
            alreadyAdded = true;
            break;
          }
        }
      }
      if (!alreadyAdded) {
        allUsers.push(users[i]);
      }
    }

    return (
      <Box p={0} className={classes.notiMain} >
        <div className={classes.root}>
          <List component="nav" aria-label="main mailbox folders">
            {
              allUsers && allUsers.length ? allUsers.map(({ id, displayName, count, notifications, roomId }) => {
                if (profile.id == id) return null;
                return <React.Fragment key={id}>

                  <ListItem
                    button
                    onClick={() => { userClick({ id, displayName, notifications }) }}
                  >
                    <ListItemIcon>
                      <Badge badgeContent={count} max={999} {...{
                        color: 'secondary',
                        children: <Avatar>
                          <ChatIcon />
                        </Avatar>,
                      }} />
                    </ListItemIcon>
                    <ListItemText primary={
                      <span className={count && classes.bold} >{displayName}</span>
                    }  />
                    {/* secondary={roomId} */}
                  </ListItem>
                  <Divider />
                </React.Fragment>
              })
                : null
            }

          </List>
        </div>
      </Box>
    )
  }
}

const mapStateToProps = (state) => {

  const users = state.firestore.ordered.users

  return {
    users,
    profile: state.firebase.profile,
    chats: state.firestore.ordered[getCollection(state.firebase.profile, 'chats')]
  }
}

export default compose(
  connect(mapStateToProps),
  firestoreConnect((props) => {
    if (props.profile.id)
      return [
        {
          collection: 'users',
          where: ['organization.id', '==', props.profile.organization && props.profile.organization.id || 'Jassu']
        },
        {
          collection: getCollection(props.profile, 'chats'),
          where: ['userIds', 'array-contains', props.profile.id]
        }
      ]

    else return []
  })
)(withStyles(styles)(ChatUsers));
